export default __webpack_public_path__ + "static/media/3-cn.940b8b2f.webp";